<template>
  <form @submit.prevent="onSearch" class="mt-3 mb-3">
    <div class="row ">
      <div class="col-lg-4 col-md-12 col-sm-12">
        <div v-if="courseNameDropdown && courseNameDropdown.length">
          <SelectVue
              v-model="filters.courseId"
              :options="courseNameDropdown"
              :is-clear="true"
              placeholder="Maßnahme"
          />
        </div>
      </div>
      <div class="col-lg-4 col-md-12 col-sm-12">
        <div v-if="clientDropdown && clientDropdown.length">
          <SelectVue
              v-model="filters.clientId"
              :options="clientDropdown"
              :is-clear="true"
              placeholder="Kostenträger"
          />
        </div>
      </div>
      <div class="col-lg-3 col-md-12 col-12 order-last order-lg-0 text-center text-lg-start mb-3 mb-lg-0">
        <SearchButton
            type="submit"
            :label="$t('general.button.search')"
            :loading="loading"/>
      </div>
      <div class="col-lg-4 col-md-6 col-sm-12">
        <div v-if="officeDropdown && officeDropdown.length">
          <SelectVue
              v-model="filters.officeId"
              :options="officeDropdown"
              :is-clear="true"
              placeholder="Standort"
          />
        </div>
      </div>
      <div class="col-lg-2 col-md-6 col-sm-12">
        <Datepicker
            v-model="filters.endDate"
            placeholder="Ende"
            position="down"/>
      </div>
    </div>
  </form>
</template>

<script setup>
import Datepicker from '@/components/picker/Datepicker.vue';
import SelectVue from '@/components/SelectVue.vue';
import { defineEmits, defineProps, toRefs, watch } from 'vue';
import SearchButton from "@/components/button/SearchButton.vue";

// Reactive filters
const props = defineProps({
  filters: {
    type: Object,
    required: true,
  },
  officeDropdown: {
    type: Array,
    required: true,
  },
  clientDropdown: {
    type: Array,
    required: true,
  },
  courseNameDropdown: {
    type: Array,
    required: true,
  },
  billingTypeDropdown: {
    type: Array,
    required: true,
  },
  loading: {
    type: Boolean,
    default: false,
  },
});

// Use toRefs to maintain reactivity
const { filters }         = toRefs(props);
const officeDropdown      = toRefs(props)[ 'officeDropdown' ];
const clientDropdown      = toRefs(props)[ 'clientDropdown' ];
const courseNameDropdown  = toRefs(props)[ 'courseNameDropdown' ];
const billingTypeDropdown = toRefs(props)[ 'billingTypeDropdown' ];
const emit                = defineEmits([ 'search' ]);

function onSearch() {
  emit('search', filters.value);
}

</script>

<style scoped>
/* Add any custom styles for your search component */
</style>
